import { render } from "./YearlyThree.vue?vue&type=template&id=4a999b65"
import script from "./YearlyThree.vue?vue&type=script&lang=js"
export * from "./YearlyThree.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__